import { Form, Formik } from "formik";
import queryString from "query-string";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import users from "../../../apiConfigs/users";
import LabelInputField from "../../../designComponents/LabelInputField/LabelInputField";
import Typography from "../../../designComponents/Typography";
import requestAPI from "../../../utils/requestAPI";
import { AcceptButton, SectionTitle } from "../../Properties/Details/styles";
import { Container, LoginWrapper } from "../../UpdatePassword/style";

const validationSchema = Yup.object().shape({
  password: Yup.string()
 .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Confirm Password is required"),
});

const UpdateAdminPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const parsedQueryString = queryString.parse(location.search);

  const token: any = parsedQueryString.token;
  const email: any = parsedQueryString.email;
  const initialValues = {
    email: email || "",
    password: "",
    confirmPassword: "",
  };

  const handleUpdatePassword = async (values: typeof initialValues) => {
    setIsLoading(true);
    try {
      await requestAPI(
        users.updateAdminPassword({
          token: token ?? "",
          email: values.email,
          password: values.password,
        })
      );
      toast.success("Password updated successfully!");
      setIsLoading(false);
      navigate("/login");
    } catch (e: any) {
      setErrorMessage(e.message);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage);
    }
  }, [errorMessage]);
  return (
    <LoginWrapper>
      <Container>
        <SectionTitle style={{ marginBottom: "15px" }}>
          Set Your Password
        </SectionTitle>

        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={handleUpdatePassword}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue, handleSubmit, touched, errors }) => (
            <Form onSubmit={handleSubmit}>
              <div className="form-wrapper" style={{ marginBottom: "15px" }}>
                <div>
                 
                  <LabelInputField
                    value={values.email}
                    onChange={(e) => setFieldValue("email", e.target.value)}
                    name="email"
                    placeHolder="Type your email eg. albertodelrio@email.xyz"
                    style={{
                      label: {
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#555A77",
                      },
                      input: {
                        height: 50,
                        border: "1px solid #F1EFFB",
                        padding: 8,
                        background: "#F1EFFB",
                        borderRadius: 6,
                        width: "100%",
                      },
                      container: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                        paddingTop: 14,
                        width: "100%",
                      },
                    }}
                    label="Email"
                  />
                </div>

                <div>
                  <LabelInputField
                    value={values.password}
                    onChange={(e) => setFieldValue("password", e.target.value)}
                    name="password"
                    placeHolder="Type your Password"
                    style={{
                      label: {
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#555A77",
                      },
                      input: {
                        height: 50,
                        border: "1px solid #F1EFFB",
                        padding: 8,
                        background: "#F1EFFB",
                        borderRadius: 6,
                        width: "100%",
                      },
                      container: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                        paddingTop: 14,
                        width: "100%",
                      },
                    }}
                    label="Password"
                  />
                  {touched.password && errors.password && (
                    <Typography style={{ color: "red", marginTop: "5px" }}>
                      {errors.password}
                    </Typography>
                  )}
                </div>

                <div>
                  <LabelInputField
                    value={values.confirmPassword}  
                    onChange={(e) =>
                      setFieldValue("confirmPassword", e.target.value)
                    }
                    name="password"
                    placeHolder="Confirm your Password"
                    style={{
                      label: {
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#555A77",
                      },
                      input: {
                        height: 50,
                        border: "1px solid #F1EFFB",
                        padding: 8,
                        background: "#F1EFFB",
                        borderRadius: 6,
                        width: "100%",
                      },
                      container: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                        paddingTop: 14,
                        width: "100%",
                      },
                    }}
                    label="Confirm Password"
                  />
                  {/* <LabelText style={{ marginBottom: "15px" }}>
                    Confirm Password
                  </LabelText>
                  <Input
                    name="confirmPassword"
                    type="password"
                    value={values.confirmPassword}
                    onChange={(e) =>
                      setFieldValue("confirmPassword", e.target.value)
                    }
                    placeholder="Confirm password"
                  /> */}
                  {touched.confirmPassword && errors.confirmPassword && (
                    <Typography style={{ color: "red", marginTop: "5px" }}>
                      {errors.confirmPassword}
                    </Typography>
                  )}
                </div>
                {errorMessage && (
                  <Typography style={{ color: "red" }}>
                    {errorMessage}
                  </Typography>
                )}

                <AcceptButton
                  isLoading={isLoading}
                  style={{ marginBottom: "20px", width: "100%" }}
                >
                  Update
                </AcceptButton>
              </div>
            </Form>
          )}
        </Formik>
      </Container>
    </LoginWrapper>
  );
};

export default UpdateAdminPassword;
